import React, { useRef, Ref } from 'react';

interface LocalizedFileInputProps {
  files: File[];
  onChange: (files: File[]) => void;
  disabled?: boolean;
  multiple?: boolean;
  chooseFilesLabel: string;
  noFileChosenLabel: string;
  className?: string;
  inputRef?: Ref<HTMLInputElement>;
}

export const LocalizedFileInput: React.FC<LocalizedFileInputProps> = ({
  files,
  onChange,
  disabled = false,
  multiple = true,
  chooseFilesLabel,
  noFileChosenLabel,
  className = '',
  inputRef,
}) => {
  const localInputRef = useRef<HTMLInputElement>(null);
  const resolvedRef = inputRef || localInputRef;
  const fileLabel = files.length > 0 ? files.map((file) => file.name).join(', ') : noFileChosenLabel;

  return (
    <div className={`flex flex-wrap items-center gap-2 ${className}`}>
      <input
        ref={resolvedRef}
        type="file"
        multiple={multiple}
        className="hidden"
        disabled={disabled}
        onChange={(e) => onChange(e.target.files ? Array.from(e.target.files) : [])}
      />
      <button
        type="button"
        onClick={() => {
          if (typeof resolvedRef === 'function') return;
          resolvedRef.current?.click();
        }}
        disabled={disabled}
        className="px-4 py-2 text-sm font-semibold rounded bg-blue-50 text-blue-700 hover:bg-blue-100 disabled:opacity-50 disabled:cursor-not-allowed"
      >
        {chooseFilesLabel}
      </button>
      <span className="text-sm text-gray-500 truncate max-w-xs" title={fileLabel}>
        {fileLabel}
      </span>
    </div>
  );
};
